import styled from "styled-components";
import { createGlobalStyle } from "styled-components";
import { H1, H3, Body1 } from '../style-comps/Common.styles';

export const Container = styled.div`
   margin-top:20px;
   margin-right:20px;
    padding: 30px;
    display: flex;
    border-radius: 16px;
    background-color: #fff;
    height: calc(90vh - 40px);
    overflow: hidden;
    width:100%;

    @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding:24px;
    overflow-y:auto;
    margin: 0;
}
`;
export const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    height: 84vh;
    width: 73vw;
    font-size: 20px;
    font-weight: bold;
    color: #61cbc9;
    background-color: white; 
    flex-direction: column;
    gap: 20px;
    border-radius: 32px;

    @media (max-width: 768px) {
    width: 100vw;
    height: 100vh;      
    border-radius: 0;   
    margin: 0;         
}
`;

export const LeftContainer = styled.div`
    flex: 0 0 25%;
    margin-right:60px;
    border-right: 1px solid #61CBC9;

    @media (max-width: 1024px) {
     margin-right:0px;
     border-right: none;

     
    }
`;

export const ListingHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;

  @media (min-width: 769px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  img {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    object-fit: cover;

    @media (min-width: 769px) {
      width: 100%;
      max-width: 300px;
      height: auto;
      margin-bottom: 24px;
    }
  }
`;

export const ErrorWarp = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin:auto;
`;

export const ErrorImg = styled.img`
   width:150px;
`;
export const ErrorP = styled.h1`
    font-size: 18px;
    font-weight: bold;
    color: #61cbc9;
`;


export const InfoCardGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
`;

export const InfoCard = styled.div`
  flex: 1 1 45%;
  min-width: 120px;
  background-color: #fff;
  border: 1px solid #61CBC9;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  box-sizing: border-box;

  h1 {
    font-size: 18px;
    margin: 0;
    color: #61CBC9;
  }

  p {
    margin: 4px 0 0;
    font-size: 12px;
    color: #555;
  }

  @media (min-width: 769px) {
    flex: 1 1 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1 {
      font-size: 20px;
    }

    p {
      font-size: 14px;
    }
  }
`;


export const ListingWrap = styled.div`  
    padding: 24px; 
    height:auto;
    
`;

export const Underline = styled.div`
    height:1px;
    width:100%;
    background-color:#61CBC9;
    margin:10px 0px;
`;

export const Title = styled(H3)`
    color: #333;
    margin-bottom: 10px;
`;

export const InfoH1 = styled(H1)`
    color: #61CBC9;
    padding:8px 0px;
`;

export const InfoBody1 = styled(Body1)`
    color: #000;
    padding:4px 0px;
`;

export const Subtitle = styled.p`
    color: #555;
    margin: 10px 0px;
    display:flex;
    align-items: center;
`;

export const RightContainer = styled.div`
    flex: 0 0 70%;
    display: flex;
    flex-direction: column;
    height: 80vh; 
    overflow: hidden; 

    @media (max-width: 768px) {
        flex: 0 0 100%;
        width: 100%;
        height: auto; 
        overflow-x: auto; /* 增加橫向滾動以防止顯示不全 */
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 10px 0;
`;

export const Button = styled.button`
    background-color: #61cbc9;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;

    &:hover {
        background-color: #4eb0a8;
    }
`;

export const DayCellWrap = styled.div`
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 0.5px solid #ddd;
  background-color: ${(props) =>
    props.isToday ? "#ffeb3b" : props.isBooked ? "#fff" : "#fff"};
  color: ${(props) => (props.isBooked ? "#0c4128" : "#000")};
  font-size: 12px;
  cursor: pointer;

  .date {
    font-size: 14px;
    font-weight: bold;
  }

  .weekday {
    font-size: 10px;
    color: #555;
  }

  &:hover {
    background: ${(props) =>
    props.status === "booked" ? "#ffaaaa" : "#b3e6c6"};
  }
`;


export const CalendarGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    text-align: center;
    flex-grow: 1;
`;

export const Day = styled.div`
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px solid #ddd;
`;

export const ReservationCell = styled.div`
    position: relative;
    flex: 1;
    min-width: 45px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 0.5px solid #ddd;
    background-color: ${(props) =>
    props.isToday ? "#ffeb3b" : props.isBooked ? "#fff" : "#fff"};
    color: ${(props) => (props.isBooked ? "#0c4128" : "#000")};
    font-size: 12px;
    cursor: pointer;

    &:hover {
        background-color: #f5f5f5;
    }

    &:hover div {
        display: flex;
    }
`;

export const ReservationFloatingDetails = styled.div`
   position: relative;
    background-color: ${(props) => props.color || "#61CBC9"};
    color: #fff;
    border-radius: 5px;
    padding: 5px;
    display: ${(props) => (props.show ? 'flex' : 'none')};
    border: none; // 確保移除整圈邊框
    border-bottom: 0px solid ${(props) => props.borderColor || "#fff"}; // 僅底部邊框
    box-sizing: border-box; // 正確處理邊框大小
`;


export const ReservationDetails = styled.div`
    display: flex;
    font-size: 0.8em;
    flex-direction: column;
    text-align: center;
    margin-top: 20px;
`;

export const DateCell = styled.div`
    padding: 10px;
    border: 1px solid #ddd;
    background-color: ${(props) => (props.isToday ? "#61cbc9" : "#fff")};
    color: ${(props) => (props.isToday ? "#fff" : "#000")};
    position: relative;
    border-radius: 5px;
    
`;

export const ReservationTag = styled.div`
    position: absolute;
    top: 30px;
    left: 5px;
    right: 5px;
    background-color: ${(props) => props.color || "#ccc"};
    color: #fff;
    font-size: 12px;
    padding: 2px;
    border-radius: 3px;
`;

export const DaySpan = styled.span`
    position: absolute;
    top: 2px;
    right:2px;
`;

export const CustomEventBox = styled.div`
  background-color: ${(props) => props.bgColor || "#61CBC9"};
  font-size: 14px;
  width: 100px;
  color: #fff;
  padding: 4px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-bottom: 0px solid transparent;
  box-sizing: border-box;
  cursor: pointer;

  @media (max-width: 768px) {
        font-size:10px;
        padding:4px 8px;
    }
`;

// 🆕 Toast 通知容器
export const ToastContainer = styled.div`
  position: fixed;
  width: auto;
  height: auto;
  right: 20px;
  top: 80px;
  background-color: ${props => props.isError ? '#dc3545' : '#61CBC9'};
  color: ${props => props.isError ? 'white' : 'black'};
  padding: 16px 40px 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100001;
  min-width: 300px;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  animation: slideIn 0.3s;
  flex-direction: column;
  font-size: 14px;
  font-weight: 500;
  white-space: pre-line;

  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

// 🆕 Toast 關閉按鈕
export const ToastCloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  color: ${props => props.isError ? 'white' : 'black'};
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

// 🆕 更新指示器
export const UpdateIndicator = styled.div`
  position: fixed;
  top: 150px;
  right: 20px;
  background-color: #61CBC9;
  color: black;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100000;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  animation: fadeIn 0.3s;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

// 🆕 Spinner Icon
export const SpinnerIcon = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid black;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const PriceTag = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  color: #2c3e50;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  pointer-events: none;
  margin-top: 4px;
  margin-left: 2px;

  @media (max-width: 768px) {
    font-size: 9px;
    padding: 1px 3px;
    margin-top: 2px;
    margin-left: 1px;
  }
`;

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;

  /* 手機：留左右安全邊距，避免 popup 貼齊螢幕兩側 */
  @media (max-width: 768px) {
    padding: 16px;
    box-sizing: border-box;
  }
`;

export const PopupContent = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  padding: 20px;
  pointer-events: auto;

  @media (max-width: 768px) {
    width: 100%;                 /* 左右邊距由 PopupOverlay 的 padding 負責 */
    max-width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    border-radius: 12px;
    padding: 16px;
    box-sizing: border-box;
  }
`;


export const GlobalStyles = createGlobalStyle`
.fc-theme-standard td, .fc-theme-standard th {
  border:none;
}

.fc {
  overflow: visible !important;
}

.fc .fc-daygrid-day,
.fc .fc-scrollgrid,
.fc .fc-daygrid {
  border: none !important;
  
}
  .fc .fc-daygrid-day .fc-daygrid-day-frame {
  position: relative;
}

.fc .fc-daygrid-day {
  border: 1px solid #ddd !important; 
  padding-top: 0px;
  
}

.fc .fc-daygrid-day.kg-blocked {
  background-color: rgba(200, 200, 200, 0.35) !important;
}

.fc .fc-daygrid-day.kg-blocked .fc-daygrid-day-frame {
  position: relative;
}

.fc .fc-daygrid-day.kg-blocked .fc-daygrid-day-frame::after {
  content: "Block";
  position: absolute;
  top: 22px;
  left: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  z-index: 2;
}


.fc .fc-daygrid-day.blocked-date {
  background-color: rgba(150, 150, 150, 0.15) !important;
}

.fc .fc-daygrid-day-top {
  position: relative;
  padding-top: 30px!important; 
  margin: 0 !important;
  min-height: 0 !important;
  line-height: 1 !important;
}

.fc .fc-daygrid-day-number {
  position: absolute;
  top: 2px;
  right: 6px;
  padding: 0 !important;
  margin: 0 !important;
}

.fc-daygrid-day-events {
  margin-top: 0px !important;
  
}

.fc .fc-col-header-cell {
  border: none !important;
  border-bottom: 2px solid #61CBC9 !important;
  background-color: rgba(97, 203, 201, 0.5) !important;
  color: black !important;
  font-weight: normal !important;
  text-transform: uppercase;
  font-size: 14px !important;
  padding: 10px 0 !important;
}

.fc .fc-view-harness {
  border-radius: 16px !important;
  overflow: hidden !important;
  background-color: #fff !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  
  
}

.fc .fc-scrollgrid {
  border-radius: 16px !important;
  overflow: hidden !important;
}

.fc .fc-daygrid {
  border-radius: 16px !important;
  overflow: hidden !important;
  border:1px solid #ddd;
}


.fc .fc-col-header {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.fc .fc-col-header-cell:first-child {
  border-top-left-radius: 16px !important;
}
.fc .fc-col-header-cell:last-child {
  border-top-right-radius: 16px !important;
}

.fc .fc-col-header-cell-cushion {
  text-align: center !important;
  display: block !important;
}

/* 事件樣式 */
.fc-event {
  border: 1px solid #ddd !important;
  font-weight: 500;
  margin-bottom: 4px;
  z-index: 1;
  transition: background-color 0.3s ease;
}

.fc-event-title {
  display: none !important;
}

.fc-event:hover {
  z-index: 2;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}

.fc-event:hover .event-icon {
  filter: brightness(1.3);
}

.fc-event.custom-event {
  transition: background-color 0.3s ease;
}
.fc-event.custom-event:hover {
  background-color: #000 !important;
}

/* FullCalendar 按鈕樣式 */
.fc .fc-button {
  background-color: #61CBC9 !important; 
  color: white !important; 
  border: none !important; 
  padding: 6px 16px !important; 
  font-size: 16px !important;
  border-radius: 5px !important; 
  box-shadow: none !important;
}

.fc .fc-button:hover {
  background-color: #4EB0A8 !important;
}

.fc .fc-button:active {
  background-color: #3D9A90 !important;
}

.fc .fc-prev-button,
.fc .fc-next-button {
  background-color: #61CBC9 !important;
  color: white !important;
  border-radius: 16px !important;
  width: 35px !important;
  height: 35px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fc .fc-prevCustom-button {
  margin-right: 4px !important;
}
.fc .fc-nextCustom-button {
  margin-right: 0px !important;
}

.fc-button-disabled {
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

.fc-daygrid-event-harness {
  margin-top: 10px !important;
  overflow: visible !important;
  z-index: 10;
  display: flex !important;
  flex-direction: row !important;  /* 桌面版橫向排列 */
  align-items: center;
  gap: 2px;
}


.fc-prevCustom-button.fc-button-disabled,
.fc-nextCustom-button.fc-button-disabled {
  background-color: rgba(114, 125, 135, 0.1) !important;
  color: #000 !important;
}

.fc .fc-toolbar {
  border: none !important;
  padding-right: 24px;
}

/* Tooltip */
.custom-tooltip {
  z-index: 9999 !important;
  background-color: #61cbc9 !important;
  color: white !important;
  font-size: 12px;
  padding: 8px 10px;
  border-radius: 6px;
  line-height: 1.4;
  text-align: left;
  opacity: 1 !important;
  backdrop-filter: none !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}



/* 手機版優化 */

@media (max-width: 1024px) {
  .fc .fc-daygrid-day-number {
    font-size: 11px !important;
    padding-right: 0px;
  }

  .fc .fc-toolbar-title {
    font-size: 16px !important;
  }

  .fc .fc-button {
    padding: 4px 8px !important;
    font-size: 14px !important;
  }

  .fc .fc-daygrid-day-frame {
    min-height: 100% !important;
    height: 100% !important;
}

  .fc .fc-daygrid-day-top {
  padding: 18px 6px 0 0 !important; 
}

  .fc .fc-daygrid-body {
    overflow-x: hidden;
  }

  .fc-daygrid-event-harness {
  flex-direction: column !important;  /* 手機版直向排列 */
  align-items: stretch !important;
  gap: 2px !important;
}

  

  .fc-daygrid-day-events {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    overflow: visible !important;
  }

  .fc-event {
    font-size: 10px !important;
    padding: 2px 4px !important;
    line-height: 1.2 !important;
    border-radius: 4px !important;
    margin-bottom: 2px !important;
  }
}

.custom-tooltip {
  z-index: 9999 !important;
}



@media (max-width: 768px) {
  .react-datepicker-popper {
    width: calc(100vw - 64px) !important;
    left: 0 !important;
    transform: none !important;
    position: relative !important;
  }

  .react-datepicker {
    width: 100% !important;
    font-size: 12px !important;
  }

  .react-datepicker__month-container {
    width: 100% !important;
    float: none !important;
  }
}


`;







